import { gql } from '@apollo/client';
import React from 'react';
import { timerIcon } from '@justgiving/icons';
import { useTranslation } from 'react-i18next';
import { PageStatus, EndDateFragment } from '../../../types/__generated__';
import usePageQuery, {
  buildQuery,
  UsePageQueryResult,
} from '../../hooks/usePageQuery';
import IconLabel from '../IconLabel/IconLabel';
import useBasePageQuery from '../../hooks/useBasePageQuery';

const FRAGMENT = buildQuery(gql`
  fragment EndDate on Page {
    id
    endDate
  }
`);

function dateToString(date: string | number) {
  return new Date(date).getTime().toString();
}

const ClosingDate: React.FunctionComponent = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  const pageData = useBasePageQuery();
  const result = usePageQuery<EndDateFragment>(FRAGMENT);

  if (!pageData?.data?.page?.status || !UsePageQueryResult.hasData(result)) {
    return null;
  }

  const { status } = pageData.data.page;
  const { endDate } = result.data;
  const translationKey =
    status === PageStatus.Completed ? 'closedOn' : 'closesOn';
  return endDate ? (
    <div className="jg-text--light">
      <IconLabel
        icon={timerIcon}
        label={t(`campaign.${translationKey}`, {
          endDate: dateToString(endDate),
        })}
      />
    </div>
  ) : null;
};

export default ClosingDate;
